<template>
  <overlay
    :show="loading"
  >
    <page-header
      screen-name="Editar Usuário"
      :link-items="linkItems"
    />

    <Form
      v-if="!loading"
      mode="update"
    />
  </overlay>
</template>

<script>

import moment from 'moment'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import { warningMessage } from '@/libs/sweetalerts'
import Form from './Form.vue'
import { getCompanyUserNoCompany } from '@/views/custom-pages/gerenciarUsuarios/requests'
import Overlay from '@/views/components/custom/overlay/Overlay.vue'
import { actions, subjects } from '@/libs/acl/rules'

export default {
  components: {
    Overlay,
    PageHeader,
    Form,
  },

  data() {
    return {
      linkItems: [
        {
          name: 'Gerenciar usuários',
          active: true,
          routeName: 'usuario-empresa-list',
        },
        {
          name: '...',
          active: true,
        },
      ],

      moment,

      loading: true,
    }
  },

  computed: {
    getItemInStore() {
      return this.$store.getters['companyUserState/getCompanyUserUpdate']
    },

    hasDnUserCompanyView() {
      return this.$can(actions.VISUALIZAR, subjects.USUARIO_EMPRESA_DN)
    },

    hasDrUserCompanyView() {
      return this.$can(actions.VISUALIZAR, subjects.USUARIO_EMPRESA_DR)
    },
  },

  created() {
    if (!this.getItemInStore) {
      this.redirectToMainPage()

      return false
    }

    if (!this.hasDnUserCompanyView && !this.hasDrUserCompanyView) {
      this.redirectToNotAuthorized()

      return false
    }

    this.$store.commit('companyUserState/clearFormData')

    return this.handleGetCompanyUserId()
  },

  methods: {
    async handleGetCompanyUserId() {
      this.loading = true

      await getCompanyUserNoCompany(this.getItemInStore.id_usuario)
        .then(response => {
          const {
            id_usuario,
            nome,
            email,
            cpf,
            data_nascimento,
            sexo,
            perfil,
          } = response.data

          this.$store.commit('companyUserState/setFormData', {
            id: id_usuario,
            nome,
            email,
            cpf,
            dataNascimento: moment(data_nascimento).format('DD/MM/YYYY'),
            sexo: { name: sexo },
            perfil: perfil[0],
            empresas: [],
          })

          this.pageTitle = nome
          this.linkItems[1].name = nome
        })
        .catch(() => {
          warningMessage('Não foi possível realizar a sua solicitação.<br /> Entre em contato com o suporte.')
        })

      this.loading = false
    },

    redirectToMainPage() {
      this.$store.commit('companyUserState/setCompanyUserUpdate', null)
      this.$router.replace({ name: 'usuario-empresa-list' })

      return false
    },

    redirectToNotAuthorized() {
      this.$store.commit('companyUserState/setCompanyUserUpdate', null)
      this.$router.replace({ name: 'misc-not-authorized' })

      return false
    },
  },
}
</script>
